import { Route, Routes } from 'react-router-dom';
import AdminDashboard from 'renderer/features/admin-dashboard/components/AdminDashboard';
import ProductsPage from 'renderer/features/products-page/components/ProductsPage';
import ProductDetailsPage from 'renderer/features/products-page/components/ProductDetailsPage';
import ProductFormPage from 'renderer/features/products-page/components/ProductFormPage';
import { selectUserRole } from 'renderer/features/auth/state/userSelectors';
import { useAppSelector } from 'renderer/shared/state/hooks';
import Purchase from 'renderer/features/purchase-page/components/Purchase';
import Users from '../../users-page/components/Users';
import Transactions from '../../payments-page/components/Transactions';
import CartPage from '../../payments-page/components/CartPage';
import CheckoutPage from '../../payments-page/components/CheckoutPage';
import ConfirmationPage from '../../payments-page/components/ConfirmationPage';
import TransactionDetail from '../../payments-page/components/TransactionDetail';
import Webhooks from '../../webhooks-page/components/Webhooks';
import WebhookDetail from '../../webhooks-page/components/WebhookDetail';
import Settings from '../../settings/components/Settings';
import UserDetails from '../../users-page/components/UserDetails';
import CreateSubscription from '../../users-page/components/CreateSubscription';
import Login from '../../auth/components/Login';
import Register from '../../auth/components/Register';
import ForgotPassword from '../../auth/components/ForgotPassword';
import ResetPassword from '../../auth/components/ResetPassword';
import Verify from '../../auth/components/Verify';
import VerifyEmailChange from '../../auth/components/VerifyEmailChange';
import Discounts from '../../discounts-page/components/DiscountsPage';
import ResellerCodes from '../../resellerCodes-page/components/ResellerCodesPage';
import Notifications from '../../notifications/components/Notifications';
import ProtectedRoutes from './ProtectedRoutes';

const Viewer = () => {
  const role = useAppSelector(selectUserRole);

  return (
    <Routes>
      <Route element={<ProtectedRoutes restrictTo="admin" />}>
        <Route
          path="/products/edit/:id"
          element={<ProductFormPage mode="edit" />}
        />
        <Route
          path="/products/add"
          element={<ProductFormPage mode="create" />}
        />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/transactions/:id" element={<TransactionDetail />} />
        <Route path="/webhooks" element={<Webhooks />} />
        <Route path="/webhooks/:id" element={<WebhookDetail />} />
        <Route path="/users" element={<Users />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/users/:userId" element={<UserDetails />} />
        <Route
          path="/users/:userId/create-subscription"
          element={<CreateSubscription />}
        />
        <Route path="/discounts" element={<Discounts />} />
        <Route path="/reseller-codes" element={<ResellerCodes />} />
      </Route>

      <Route element={<ProtectedRoutes restrictTo="user" />}>
        <Route
          path="/dashboard"
          element={role === 'admin' ? <AdminDashboard /> : <UserDetails />}
        />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="/cart/:id" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/confirmation" element={<ConfirmationPage />} />
      <Route path="/" element={<ProductsPage />} />
      <Route path="/store/:categoryId" element={<ProductsPage />} />
      <Route path="/products/:id" element={<ProductDetailsPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/verify-email-change" element={<VerifyEmailChange />} />
      <Route path="/purchase" element={<Purchase />} />
    </Routes>
  );
};

export default Viewer;
